import React from 'react';
import { Form } from 'formik';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import JobApplicationCard from 'buyside/components/presentation/JobApplicationsPage/JobApplicationCard/jobApplicationCard';
import CoverLetterField from 'buyside/components/presentation/JobApplicationsPage/CoverLetterField/coverLetterField';

const JobApplicationForm = ({ currentUser, ...props }) => (
  <Form>
    <JobApplicationCard currentUser={currentUser} {...props} />
    {props.jobPost.coverLetter !== 'unwanted' && <CoverLetterField {...props} />}
    {currentUser.profile.resume && (
      <Button
        isLoading={props.isSubmitting}
        text="Submit Application"
        type={BUTTON_TYPES.PRIMARY}
      />
    )}
  </Form>
);

export default JobApplicationForm;
